import { render, staticRenderFns } from "./SithMesQualityDocumentList.vue?vue&type=template&id=1b9560f4&"
import script from "./SithMesQualityDocumentList.vue?vue&type=script&lang=js&"
export * from "./SithMesQualityDocumentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports